(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tt/views/start.js') >= 0) return;  svs.modules.push('/modules/tt/views/start.js');
(function(svs, Handlebars) {
_svs=window.svs=window.svs||{};
_svs.tt=_svs.tt||{};
_svs.tt.templates=_svs.tt.templates||{};
svs.tt.templates.start = Handlebars.template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<div class=\"tt-container\">\n    <div class=\"tt-sidebar\">\n        <div class=\"tt-navigation\"></div>\n        <div class=\"tt-filter\"></div>\n    </div>\n    <main aria-labelledby=\"main-heading\" class=\"tt-main\"></main>\n</div>\n";
},"useData":true});
Handlebars.partials['svs-tt-start'] = svs.tt.templates.start;
})(svs, Handlebars);


 })(window);